import React from 'react';
import { CheckIcon } from '../lib/icons';
import { useReveal } from '../lib/useReveal';
const INCLUDED = [{
  icon: '📚',
  text: '6 Tomos Premium'
}, {
  icon: '🎁',
  text: '4 Bonos Exclusivos'
}, {
  icon: '📱',
  text: 'Acceso inmediato'
}, {
  icon: '♾️',
  text: 'Acceso de por vida'
}, {
  icon: '💻',
  text: 'Compatible con todos tus dispositivos'
}, {
  icon: '📥',
  text: 'Descarga inmediata'
}];
export function PricingSection() {
  const [ref, visible] = useReveal();
  return <section id="inscripcion" className="border-t border-white/5 bg-[#101914] px-4 py-14 text-white md:py-20" data-id="element-211" data-mp="1s9des4utt7tv">
      <div ref={ref} className={`reveal container mx-auto max-w-3xl rounded-3xl border border-[#e6a45c]/45 bg-[#17231c] p-7 text-center shadow-2xl md:p-11 ${visible ? 'is-visible' : ''}`} data-id="element-212" data-mp="1x86wk9h5bkzu">
        <p className="mb-4 text-sm font-bold uppercase tracking-[0.22em] text-[#e6a45c]" data-id="element-213" data-mp="2uyv3yyo0b58">Tu colección digital</p>
        <h2 className="mb-8 font-serif text-3xl font-bold text-white md:text-5xl" data-id="element-214" data-mp="7t0deho9o6fn">¿Qué incluye tu compra?</h2>
        <div className="mb-8 grid gap-3 text-left sm:grid-cols-2" data-id="element-215" data-mp="1mhq1qds25mif">
          {INCLUDED.map(item => <div key={item.text} className="flex items-center gap-3 rounded-xl border border-white/10 bg-[#101914] p-4 text-stone-200" data-id="element-216" data-mp="1hpog41902jfq"><span className="text-xl" aria-hidden="true" data-id="element-217" data-mp="1crmwnf7nwi3q">{item.icon}</span><span className="font-medium" data-id="element-218" data-mp="17saeh7rqjz7h">{item.text}</span><CheckIcon className="ml-auto h-4 w-4 shrink-0 text-[#e6a45c]" strokeWidth={3} data-id="element-219" data-mp="17td133i0zfhl" /></div>)}
        </div>
        <a href="https://montanismo-guia-de-montana.impultienda.ar/checkout" className="block w-full rounded-xl border border-[#f4c481]/50 bg-[#c65a2e] px-6 py-4 font-serif text-lg font-bold tracking-[0.08em] text-white transition-colors hover:bg-[#a94622] md:py-5 md:text-xl" data-id="element-220" data-mp="25dg5a5fn2qyf">QUIERO ACCEDER AHORA</a>
        <p className="mt-4 text-xs leading-relaxed text-stone-500" data-id="element-221" data-mp="1rhu6x7nimutc">Accedé a la colección y comenzá a prepararte para tu próxima aventura.</p>
      </div>
    </section>;
}